import React, { useState } from 'react';
import './Auth.css';

export function ForgotPassword({ onBack }) {
  const [email, setEmail] = useState('');
  const [sent, setSent]   = useState(false);

  return (
    <div className="auth-shell">
      <div className="auth-left">
        <div className="auth-card">
          <button className="auth-back" onClick={onBack}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>
            Back to login
          </button>
          <h1 className="auth-title">Reset Password</h1>
          {!sent ? (
            <>
              <p style={{ color: '#6b7b79', fontSize: 14, marginBottom: 24, fontFamily: 'var(--font-ui)' }}>
                Enter your email and we'll send you a reset link.
              </p>
              <div className="auth-field">
                <input type="email" placeholder="Email Address" value={email} onChange={e => setEmail(e.target.value)} className="auth-input" />
              </div>
              <button className="auth-btn" onClick={() => setSent(true)}>Send Reset Link</button>
            </>
          ) : (
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
              <div style={{ fontSize: 48, marginBottom: 16 }}>📧</div>
              <p style={{ color: 'var(--accent)', fontFamily: 'var(--font-display)', fontSize: 18, marginBottom: 8 }}>Link sent!</p>
              <p style={{ color: '#6b7b79', fontSize: 13, fontFamily: 'var(--font-ui)' }}>Check your email for the reset link.</p>
              <button className="auth-back" onClick={onBack} style={{ margin: '24px auto 0', display: 'flex' }}>Back to login</button>
            </div>
          )}
        </div>
      </div>
      <div className="auth-right">
        <div className="auth-welcome"><h2>Forgot your <span>password?</span></h2><p>No worries, we've got you covered</p></div>
      </div>
    </div>
  );
}

export function ResetPassword({ onBack }) {
  const [pw, setPw]   = useState('');
  const [pw2, setPw2] = useState('');

  return (
    <div className="auth-shell">
      <div className="auth-left">
        <div className="auth-card">
          <button className="auth-back" onClick={onBack}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>
            Back to login
          </button>
          <h1 className="auth-title">New Password</h1>
          <div className="auth-field">
            <input type="password" placeholder="New password (min 8 chars)" value={pw} onChange={e => setPw(e.target.value)} className="auth-input" />
          </div>
          <div className="auth-field">
            <input type="password" placeholder="Confirm new password" value={pw2} onChange={e => setPw2(e.target.value)} className="auth-input" />
          </div>
          <button className="auth-btn" onClick={onBack}>Update Password</button>
        </div>
      </div>
      <div className="auth-right">
        <div className="auth-welcome"><h2>Set a new <span>password</span></h2></div>
      </div>
    </div>
  );
}

export default ForgotPassword;
